import { put, call, takeLatest, select, fork } from 'redux-saga/effects';

import config from 'config';

import { loading } from './duck';

import { logout } from 'actions/auth';
import { connectWs } from 'actions/websockets';
import { fetchMe } from 'actions/base';
import { fetchRoutes } from 'actions/routes';
import { setUserContext } from 'modules/sentry';

import { initAnalytics, identifyToSegment, identifyToInspectlet } from 'redux/modules/analytics';
import { setClientConfig } from 'redux/modules/client-config/duck';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

// @effect Action
const initApp$ = 'app/initApp$';

// Move to a common place
const getStored = (key) => {
  const val = localStorage.getItem(key);
  return (val && val !== 'undefined' && JSON.parse(val)) || null;
};

// @effect Creators
export const initApp = (payload) => ({
  type: initApp$,
  payload,
});

function* fetchFromBackend() {
  yield put(loading(true));

  const user = yield put.resolve(fetchMe());

  const mercuryUser = getStored('mercuryUser');
  mercuryUser['country_settings'] = user.country_settings;
  localStorage.setItem('mercuryUser', JSON.stringify(mercuryUser));

  yield fork(identifyToSegment, { user });
  yield fork(identifyToInspectlet, { user });

  yield call(setUserContext, {
    email: user.username,
    id: user.id,
    name: user.name,
  });

  const isOntruck = getTenantPreLoginConfig().company_name === 'Ontruck';
  const isIntraser = getTenantPreLoginConfig().company_name === 'Intraser';
  const shouldFetchRoutes = isOntruck || isIntraser;

  if (shouldFetchRoutes) {
    yield put.resolve(fetchRoutes());
  }

  yield put(setClientConfig(user));
  yield put(connectWs());
  yield put(loading(false));
}

function* initAppWorker() {
  try {
    const user = yield select((state) => state.user);

    if (user) {
      yield call(fetchFromBackend);
      yield call(initAnalytics, { segmentKey: config.SEGMENT_KEY });
    } else {
      yield put(loading(false));
    }
  } catch (err) {
    yield put(loading(false));
    yield put(logout());
  }
}

// Watchers
export function* watchApp() {
  yield takeLatest(initApp$, initAppWorker);
}
